import React from 'react'
import { inject, observer } from 'mobx-react'
import DocumentTitle from 'react-document-title'
import Spinner from '@components/spinner'

const SurveyView = ({ id, c, projectStore }) => {

  if(projectStore.loading) return <Spinner />

  return (
    <DocumentTitle
      title={`${projectStore.project.projectName} - Survey | Atheneum Partners`}>
      <iframe
        title={`${projectStore.project.projectName} - Survey | Atheneum Partners`}
        src={`${process.env.REACT_APP_SURVEY_APP_URL}/SurveyEditEmbed?embed=1&projectId=${projectStore.project.id}`}
        // src={`${
        //   process.env.REACT_APP_SURVEY_APP_URL
        // }?t=${localStorage.getItem('ngStorage-accessToken')}&p=${id}${
        //   c ? `&c=${c}` : ''
        // }`}
        style={{ height: 'calc(100vh - 210px)', width: '100%', border: '0' }}
      />
    </DocumentTitle>
  )
}

export default inject(
  'projectStore'
)(observer(SurveyView))
